module.exports = __webpack_public_path__ + "img/adspark.7c8e26c7.png";